module.exports = __webpack_public_path__ + "front/img/20.24ca54bd.jpg";